<template>
  <a-alert show-icon type="info" class="blue-alert">
    <template #message>
      <div v-if="!customText">
        {{
            isInstruments ? 'Инструменты доступны по подписке.' : 'Доступен по подписке.'
        }}
        <span class="subscription-action-text" @click="showOrderForm">Оформить</span>
      </div>
      <div v-else>
        {{
          customText
        }}
        <span class="subscription-action-text" @click="showOrderForm">Оформить подписку</span>
      </div>
    </template>

    <template #icon>
      <InfoCircleFilled style="color: var(--main-blue)" />
    </template>
  </a-alert>
</template>

<script>
import {InfoCircleFilled} from "@ant-design/icons-vue";

export default {
  components: {InfoCircleFilled},
  props: {
    isInstruments: Boolean,
    customText: String,
  },
  emits: ['showOrder'],
  setup(props, context) {
    const showOrderForm = () => {
      context.emit('showOrder');
    }

    return {
      showOrderForm,
    }
  }
}
</script>


<style scoped lang="scss">
.blue-alert {
  border: unset;
  border-radius: 6px;

  :deep(.ant-alert-message) {
    padding: 8px 0;
  }
}

.subscription-action-text {
  font-weight: 700;
  text-decoration: underline;
  cursor: pointer;
}
</style>